import { configureStore } from "@reduxjs/toolkit"
import { setupListeners } from "@reduxjs/toolkit/query"
import { accountApi } from "../services/account.service"
import { affiliateApi } from "../services/affiliate.service"
import { affiliateProductProgramsApi } from "../services/product-programs.service"

export const store = configureStore({
    reducer: {
        [accountApi.reducerPath]: accountApi.reducer,
        [affiliateApi.reducerPath]: affiliateApi.reducer,
        [affiliateProductProgramsApi.reducerPath]: affiliateProductProgramsApi.reducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware()
            .concat(accountApi.middleware)
            .concat(affiliateApi.middleware)
            .concat(affiliateProductProgramsApi.middleware),
})

setupListeners(store.dispatch)